module.exports = __webpack_public_path__ + "img/BoD_11_Ms_Theresa_Goh.1255767b.jpg";